import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Crown } from "@phosphor-icons/react";

export default function Setup() {
  const { setup } = useAuth();
  const [f, setF] = useState({ username: "", name: "", password: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!f.username.trim() || !f.password) { toast.error("Username and password required"); return; }
    if (f.password.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    if (f.password !== f.confirm) { toast.error("Passwords don't match"); return; }
    setBusy(true);
    try {
      await setup(f.username.trim(), f.password, f.name.trim());
      toast.success("Owner account created — welcome");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Setup failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" data-testid="setup-page">
      <div className="w-full max-w-md surface p-8 fade-up">
        <div className="flex items-center gap-3 mb-2">
          <Crown size={24} weight="duotone" className="text-emerald-700" />
          <div className="font-display text-3xl leading-none text-slate-900">First-time Setup</div>
        </div>
        <p className="text-sm text-slate-500 mb-6">Create the shop owner account. This first user always has full access. You can add employees later.</p>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <Label className="text-xs text-slate-600">Full Name</Label>
            <Input data-testid="setup-name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Mike Owner" />
          </div>
          <div>
            <Label className="text-xs text-slate-600">Username *</Label>
            <Input data-testid="setup-username" value={f.username} onChange={(e) => setF({ ...f, username: e.target.value })} placeholder="mike" autoComplete="username" />
          </div>
          <div>
            <Label className="text-xs text-slate-600">Password *</Label>
            <Input data-testid="setup-password" type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} autoComplete="new-password" />
          </div>
          <div>
            <Label className="text-xs text-slate-600">Confirm Password *</Label>
            <Input data-testid="setup-confirm" type="password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} autoComplete="new-password" />
          </div>
          <button type="submit" disabled={busy} className="btn-primary w-full mt-2" data-testid="setup-submit">
            {busy ? "Creating…" : "Create Owner Account"}
          </button>
        </form>
      </div>
    </div>
  );
}
